<script>
  import gql from 'graphql-tag'

  import {
    limit,
    join,
    truncate,
  } from '@/filters'

  const findBook = gql`
    query findBook($id: String) {
      livre(id: $id) {
        id
        titre
        sous_titre
        couverture: couverture_url
        auteurs {
          nom
        }
      }
    }
  `

  export default {
    name: 'SearchBookItem',
    props: {
      titre: {},
      id: {
        // default: () => [],
        type: String,
      },
    },
    filters: {
      limit,
      join,
      truncate,
    },
    data () {
      return {
        livre: null,
        loadingTitres: 0,
        searchQuery: '',
      }
    },
    apollo: {
      livre: {
        query: findBook,
        loadingKey: 'loadingTitres',
        variables () {
          return {
            id: this.id,
          }
        },
        skip () {
          return !this.id
        },
      },
    },
    computed: {
      isLoading () {
        return !!this.loadingTitres
      },
      auteurs () {
        return this.livre && this.livre.auteurs.map(({ nom }) => nom).slice(0, 2).join(', ')
      },
    },
    methods: {},
  }
</script>

<template lang="pug">

div.book
  div.coverwrapper.animated-background
    template(v-if="livre")
      img(v-if="livre.couverture", :src="livre.couverture")
  div.infos
    h4.title {{ titre.titre | truncate(50) }}
    h6.auteurs {{ auteurs }}
</template>

<style lang="postcss" scoped>

  .book {
    height: 90px;
    display: flex;
    & .coverwrapper {
      background-color: grey;
      width: 80px;
      flex-shrink: 0;
      overflow: hidden;
    }
    & .infos {
      padding: 10px;
      padding-left: 25px;
    }
    & .title {
      font-weight: bold;
      font-size: 1.4em;
      color: rgb(126,126,126);
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
    }
    & .auteurs {
      font-weight: 400;
      font-size: 1.2em;
      color: rgb(68,68,68);
    }

    @keyframes placeHolderShimmer {
      0% {
        background-position: -468px 0
      }
      100% {
        background-position: 468px 0
      }
    }

    .animated-background {
      animation-duration: 1s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
      animation-name: placeHolderShimmer;
      animation-timing-function: linear;
      background: #f6f7f8;
      background: #eeeeee;
      background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
      background-size: 800px 104px;
      position: relative;
    }


  }

</style>



// WEBPACK FOOTER //
// search-item-book.vue?6ce1284a